"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLogin = isLogin;
exports.call = call;
exports.setTitle = setTitle;
exports.login = login;
exports.route = route;
exports.pay = pay;
exports.getNativeShareConfig = getNativeShareConfig;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.promise");

var _env = require("./env");

var _session = require("./session");

var _urlParams = require("./urlParams");

var _config = require("../config");

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// 是否登录,session中st和sid都不为-1时登录
function isLogin() {
  return new Promise(function (resolve, reject) {
    (0, _session.getSession)().then(function (resp) {
      var st = resp.st,
          sid = resp.sid;

      if (st !== -1 && sid !== -1) {
        resolve();
      } else {
        reject();
      }
    });
  });
} // 打电话


function call() {
  var _phone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var phone = "".concat(_phone);

  if ((0, _env.isApp)()) {
    var WLPhone = window.WLSDK.WLPhone;
    WLPhone && WLPhone.makeCall({
      phone: phone
    });
  } else {
    location.href = "tel:".concat(phone);
  }
} // 设置标题


function setTitle() {
  var _title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var title = "".concat(_title); // if (isApp()) {
  //   const { WLNavigation } = window.WLSDK;
  //   WLNavigation && WLNavigation.setWindowTitle({
  //     title
  //   });
  // } else {

  window.document.title = title; // IOS weixin qq 需要加载资源来告诉浏览器去刷新title

  if (_env.device === 'ios') {
    var iframe = window.document.createElement('iframe');
    iframe.src = _config.UTILS.setTileSrc;
    iframe.style.visibility = 'hidden';
    iframe.style.width = '1px';
    iframe.style.height = '1px';

    iframe.onload = function () {
      setTimeout(function () {
        window.document.body.removeChild(iframe);
      }, 0);
    };

    document.body.appendChild(iframe);
  } // }

} // 登录


function login() {
  var uri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config.ROUTE.login;
  return new Promise(function (resolve, reject) {
    isLogin().then(resolve).catch(function () {
      var WLRouter = window.WLSDK.WLRouter;

      if (WLRouter) {
        WLRouter.route({
          uri: uri,
          callback: function callback(resp) {
            if (resp.content.result) {
              (0, _session.getSession)().then(resolve);
            } else {
              reject();
            }
          }
        }).catch(reject);
      } else {
        reject();
      }
    });
  });
}
/**
 * 跳转地址
 * 入参：
 *  {String| Boolean} {required} ：url或者参数对象
 *  {Boolean} ：是否统跳
 *  {String} ：h5统跳的地址
 */


function route() {
  var urlOrParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var native = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var commonWebUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _config.ROUTE.web;
  return new Promise(function (resolve, reject) {
    var WLRouter = window.WLSDK.WLRouter;
    var params = {
      url: urlOrParams,
      native: native,
      commonWebUrl: commonWebUrl
    };

    if (_typeof(urlOrParams) === 'object') {
      params = _objectSpread({}, params, {
        url: ''
      }, urlOrParams);
    }

    if (params.url && params.url.indexOf('wlqq://') === 0) {
      params.native = true;
      params.commonWebUrl = null;
    }

    if (params.native && WLRouter) {
      if (params.commonWebUrl) {
        params.url = (0, _urlParams.setUrlParams)(params.commonWebUrl, {
          url: encodeURIComponent(params.url)
        });
      }

      WLRouter.route(_objectSpread({}, params, {
        uri: params.url,
        callback: function callback(resp) {
          if (resp.content.result) {
            resolve();
          } else {
            reject();
          }
        }
      })).catch(reject);
    } else {
      window.location.href = params.url;
    }
  });
}
/**
 * 支付
 * 入参：
 *  {Object} {required} ：支付参数
 *    {String} {required} orderNo：订单号
 *    {String} {required} shopNo：商户号
 *    {String} paymentScene：优惠券支付场景 4
 *    {String} couponJson：优惠券jsonarray encodeURIComponent(JSON.stringify(couponJson))
 *    {String} productPriceJson：优惠券支付的商品的jsonarray
 *    {String} qrId：扫码支付二维码id
 *  {String} ：支付地址
 */


function pay() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _config.ROUTE.pay;
  return new Promise(function (resolve, reject) {
    var WLRouter = window.WLSDK.WLRouter;

    if (WLRouter) {
      var uri = (0, _urlParams.setUrlParams)(url, data);
      WLRouter.route({
        uri: uri,
        callback: function callback(resp) {
          if (resp.content.result) {
            resolve();
          } else {
            reject();
          }
        }
      }).catch(reject);
    } else {
      reject();
    }
  });
}
/**
 * 获取app端分享需要的配置信息
 *  {Object} {required} ：对象参数
 *    {String} {required} url：分享链接
 *    {String} {required} title：分享标题
 *    {String} {required} text：分享内容
 *    {String} {required} imageUrl：分享图片链接
 *    {String} channel：渠道，默认值：货车帮
 *    {String} site：2048
 */


function getNativeShareConfig(config) {
  var url = config.url,
      title = config.title,
      text = config.text,
      imageUrl = config.imageUrl;
  var channel = config.channel || '货车帮';
  var site = config.site || '2048';
  return {
    QQ: {
      title: title,
      titleUrl: url,
      text: text,
      imageUrl: imageUrl,
      url: url,
      channel: channel
    },
    QZone: {
      title: title,
      titleUrl: url,
      text: text,
      imageUrl: imageUrl,
      url: url,
      site: site,
      channel: channel
    },
    Wechat: {
      title: title,
      text: text,
      imageUrl: imageUrl,
      url: url,
      channel: channel
    },
    WechatMoments: {
      title: title,
      text: text,
      imageUrl: imageUrl,
      url: url,
      channel: channel
    },
    ShortMessage: {
      title: '',
      url: '',
      imageUrl: '',
      text: "".concat(text).concat(url),
      channel: channel
    },
    CopyLink: {
      title: '',
      text: '',
      imageUrl: '',
      url: url,
      channel: channel
    }
  };
}